module.exports = __webpack_public_path__ + "img/xinyang_gongzhonghao.b976d9da.jpg";